import React from "react";
// import map from "ramda/src/map";
// import compose from "ramda/src/compose";
// import set from "ramda/src/set";
// import lensProp from "ramda/src/lensProp";
import Switch from '@mui/material/Switch';

// import Api from "../../services/Api";
// import useAuth from "../../routes/login/AuthContext";

import { Grid } from "../../UI/Grid";
// import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { COLOR_WHITE } from "../../constants/styles";
// import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
// import { useSnackbar } from "../../hooks/useSnackbar";
import { L2Selector } from "../../common/network/NetworkSelectors";
import { Network, IExtendedL3 } from "../../services/NetworkApi";
// import {
//   useNetworkContext,
//   useSelectedNetworkContext,
// } from "../../contexts/NetworkContext/context";

interface IProps {
  unitTypes: IExtendedL3[];
  updateData: React.Dispatch<React.SetStateAction<IExtendedL3[]>>;
  getData: () => Promise<void>;
  showArchived: boolean;
  subnetwork?: number;
  setSubnetwork: (subnetwork: number) => void;
  changeArchivedVisiblity: (_: any, checked: boolean) => void;
}

export const SetAllToButtons: React.FC<IProps> = (props) => {
  // const { getAuthToken, isSuperAdminRead } = useAuth();
  // const { loadNetworkInfoForNetworks } = useNetworkContext();
  // const { selectedNetworkId } = useSelectedNetworkContext();
  // const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  // const [isAllowLoading, setIsAllowLoading] = React.useState(false);
  // const [isNotAllowLoading, setIsNotAllowLoading] = React.useState(false);

  // const handleError = () =>
  //   showErrorSnackbar("An error occurred. Please try again");

  // const onComplete = async () => {
  //   await loadNetworkInfoForNetworks([selectedNetworkId]);
  //   showSuccessSnackbar("Saved Changes");
  //   await props.getData();
  // };
  
  const l2Filter = (l2: Network) => (l2.matchingRoundStatus !== "ARCHIVED");

  // const updateLocalData = (newNewMatchingAllowed: boolean) =>
  //   props.updateData(
  //     compose(
  //       map(
  //         set(
  //           lensProp("forcedClosed"),
  //           newNewMatchingAllowed
  //         )
  //       ),
  //       map(
  //         set(
  //           lensProp("forcedClosed"),
  //           newNewMatchingAllowed
  //         )
  //       )
  //     )
  //   );
  
  // const filterUnitTypes = (u: IExtendedL3) => u.matchingRoundStatus !== "CLOSED" && u.matchingRoundStatus !== "ARCHIVED";

  // const pauseAll = async () => {
  //   const body = {
  //     subnetworkCommands: [],
  //     unitTypeCommands: props.unitTypes.filter(filterUnitTypes).map((item) => ({
  //       l1Id: selectedNetworkId,
  //       l2Id: item.l2Id,
  //       l3Id: item.l3Id,
  //       forcedClosed: true,
  //     })),
  //   };

  //   setIsAllowLoading(true);

  //   Api.setMathingRules(selectedNetworkId, body, await getAuthToken())
  //     .then(compose(() => updateLocalData(true)), onComplete)
  //     .catch(handleError)
  //     .finally(() => setIsAllowLoading(false));
  // };

  // const unpauseAll = async () => {
  //   const body = {
  //     subnetworkCommands: [],
  //     unitTypeCommands: props.unitTypes.filter(filterUnitTypes).map((item) => ({
  //       l1Id: selectedNetworkId,
  //       l2Id: item.l2Id,
  //       l3Id: item.l3Id,
  //       forcedClosed: false,
  //     })),
  //   };

  //   setIsNotAllowLoading(true);

  //   Api.setMathingRules(selectedNetworkId, body, await getAuthToken())
  //     .then(compose(() => updateLocalData(false)), onComplete)
  //     .catch(handleError)
  //     .finally(() => setIsNotAllowLoading(false));
  // };

  return (
    <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
      <Grid item>
        <L2Selector
          onSelectHandler={props.setSubnetwork}
          variant="table"
          defaultValue={0}
          filter={!props.showArchived? l2Filter : undefined}
          extraMenuOptions={[{ value: 0, label: "All Matching Rounds" }]}
        />
      </Grid>
      <Grid item>
        <Typography color={COLOR_WHITE}> Show Archived
          <Switch value={props.showArchived} onChange={props.changeArchivedVisiblity}/>
        </Typography>
      </Grid> 
      {/* <Grid item>
        <Typography color={COLOR_WHITE}>Set All To:</Typography>
      </Grid>
      <Grid item>
        <ReadOnlyWrapper>
          <Button
            isLoading={isAllowLoading}
            isDisabled={isNotAllowLoading || isSuperAdminRead()}
            appearance="primary"
            onClick={pauseAll}
          >
            Enabled
          </Button>
        </ReadOnlyWrapper>
      </Grid>
      <Grid item>
        <ReadOnlyWrapper>
          <Button
            isDisabled={isAllowLoading || isSuperAdminRead()}
            isLoading={isNotAllowLoading}
            appearance="primary"
            onClick={unpauseAll}
          >
            Paused
          </Button>
        </ReadOnlyWrapper>
      </Grid> */}
    </Grid>
  );
};
